module.exports = __webpack_public_path__ + "static/machine02-989d9f9b8eb55e9b29e76a0433212295.png";